import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
// @ts-ignore
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import Modal from "@/components/Modal.vue";
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
import TariffList from "@/types/Tariff/TariffList";
let SalesOrders = class SalesOrders extends Vue {
    updateSalesOrder() {
        this.$data.loading = true;
        this.$store
            .dispatch("updateSalesOrder", this.$data.selectedSalesOrder)
            .then((result) => {
            this.loadSalesOrders();
            this.$data.modals.edit = false;
            this.$data.selectedSalesOrder = null;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "SalesOrders.vue -> loadSalesOrders");
        })
            .finally(() => {
            this.$data.loading = false;
        });
    }
    openEdit(salesOrder) {
        this.$data.selectedSalesOrder = { ...salesOrder };
        this.$data.modals.edit = true;
    }
    initLoad() {
        Promise.all([this.$store.dispatch("loadGlobalTariffsAsync")])
            .then((values) => {
            this.$data.tariffList = new TariffList(values[0].data);
            this.$data.preloaded = true;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "SalesOrders.vue -> initalLoad");
            this.$data.preloaded = true;
        });
    }
    loadSalesOrders() {
        this.$data.loading = true;
        this.$store
            .dispatch("getSalesOrdersAsync")
            .then((result) => {
            this.$data.salesOrders = result.data;
            this.$data.loading = false;
        })
            .catch((err) => {
            this.$data.loading = false;
            window.errorHandler.logError(err, "SalesOrders.vue -> loadSalesOrders");
        });
    }
    createSalesOrder() {
        this.$data.loading = true;
        this.$store
            .dispatch("createSalesOrder", this.$data.createSalesOrderData)
            .then((result) => {
            this.loadSalesOrders();
            this.$data.modals.createSalesOrder = false;
            this.$data.createSalesOrderData = null;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "SalesOrders.vue -> createSalesOrder");
        })
            .finally(() => {
            this.$data.loading = false;
        });
    }
    confirmDeleteSalesOrder(item) {
        this.$data.salesOrderToRemove = item;
        this.$data.modals.confirmDeleteSalesOrder = true;
    }
    deleteSalesOrder() {
        this.$data.loading = true;
        this.$store
            .dispatch("deleteSalesOrder", this.$data.salesOrderToRemove)
            .then((result) => {
            this.$data.loading = false;
            this.loadSalesOrders();
            this.$data.modals.edit = false;
            this.$data.modals.confirmDeleteSalesOrder = false;
        })
            .catch((err) => {
            this.$data.loading = false;
            window.errorHandler.logError(err, "SalesOrders.vue -> deleteSalesOrder");
        });
    }
    showCreateModal() {
        this.$data.createSalesOrderData = {
            ...this.$data.createSalesOrderTemplate,
        };
        this.$data.modals.createSalesOrder = true;
    }
    selectSalesOrderFromDate() {
        this.$data.createSalesOrderData.from = moment(this.$data.createSalesOrderData.from).format("YYYY-MM-DD[T]00:00:00[Z]");
    }
    selectSalesOrderToDate() {
        this.$data.createSalesOrderData.to = moment(this.$data.createSalesOrderData.to).format("YYYY-MM-DD[T]00:00:00[Z]");
    }
};
SalesOrders = __decorate([
    Component({
        data() {
            return {
                filter: "",
                theme: this.$store.getters.getTheme,
                salesOrders: null,
                onlyActive: true,
                //modals
                modals: {
                    createSalesOrder: false,
                    tariffEdit: false,
                    confirmDeleteSalesOrder: false,
                    edit: false,
                },
                salesOrderToRemove: null,
                createSalesOrderTemplate: {
                    customerContactPerson: "",
                    customerName: "",
                    customerPurchaseId: "",
                    fixedAmount: null,
                    invoiceType: "",
                    name: "",
                    from: "",
                    to: "",
                    userId: "",
                    tariffIds: [],
                },
                createSalesOrderData: null,
                preloaded: false,
                tariffList: null,
                loading: false,
                selectedSalesOrder: null,
                salesOrdersHeaders: [
                    { text: "Name", value: "name" },
                    { text: "Customer", value: "customerName" },
                    { text: "Contact Person", value: "customerContactPerson" },
                    { text: "From", value: "from" },
                    { text: "To", value: "to" },
                ],
            };
        },
        computed: {
            tariffs() {
                try {
                    return this.$store.state.globalTariffs.tariffs.sort((a, b) => a.customerName.localeCompare(b.customerName));
                }
                catch {
                    return [];
                }
            },
            employees() {
                try {
                    return this.$store.state.globalEmployeesAdmin.employees
                        .filter((emp) => !emp.endOfEmployment)
                        .sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`));
                }
                catch {
                    return [];
                }
            },
            filteredSalesOrders() {
                if (!this.$data.onlyActive) {
                    return this.$data.salesOrders;
                }
                const filtered = this.$data.salesOrders.filter((order) => !(order.to && order.to < new Date().toISOString()));
                return filtered;
            },
        },
        mounted() {
            this.initLoad();
            this.loadSalesOrders();
        },
        components: {
            IconBox,
            IconBoxContent,
            WhiteBox,
            Modal,
            DatePickerTextbox,
        },
        methods: {
            setOrderAsCreateOrderAndStripId(salesOrder) {
                const order = JSON.parse(JSON.stringify(salesOrder));
                delete order.id;
                this.$data.createSalesOrderData = order;
                this.$data.selectedSalesOrder = null;
                this.$data.modals.edit = false;
                this.$data.modals.createSalesOrder = true;
            },
        },
    })
], SalesOrders);
export default SalesOrders;
